import {
	ActionButtonsState,
	SET_ACTION_BUTTONS_VISIBLE,
	SET_SHOW_FUNCTION_SLEEP,
	SET_SHOW_FUNCTION_STORAGE,
	SET_SHOW_FUNCTIONS,
	SET_SHOW_MEASUREMENTS,
	SET_SHOW_SELECT_ALL,
} from './types';
import { Actions } from '..';
import { SET_SCENE_DATA } from '../scene';
import { ProductUtils } from '../../util/ProductUtils';
import { SET_APP_VIEW } from '../application/types';
import { SET_SELECTED_CONFIGURATION } from '../sofaConfiguration/types';

const initialState: ActionButtonsState = {
	actionButtonsVisible: false,
	showMeasurements: true,
};

export function actionButtonsReducer(state = initialState, action: Actions): ActionButtonsState {
	switch (action.type) {
		case SET_ACTION_BUTTONS_VISIBLE:
			return { ...state, actionButtonsVisible: action.value };
		case SET_SHOW_FUNCTION_SLEEP: {
			const showFunctionSleep = action.value;
			const showSelectAll = false;
			return { ...state, showFunctionSleep, showSelectAll };
		}
		case SET_SHOW_FUNCTION_STORAGE: {
			const showFunctionStorage = action.value;
			const showSelectAll = false;
			return { ...state, showFunctionStorage, showSelectAll };
		}
		case SET_SHOW_FUNCTIONS: {
			const showFunctions = action.value;
			const showSelectAll = false;
			return { ...state, showFunctions, showSelectAll };
		}
		case SET_SHOW_MEASUREMENTS: {
			const showMeasurements = action.value;
			return { ...state, showMeasurements };
		}
		case SET_SHOW_SELECT_ALL: {
			const showSelectAll = action.value;
			return { ...state, showSelectAll };
		}
		case SET_SCENE_DATA: {
			const { sceneItems, products, models, rangeSettings } = action;
			const disableShowFunctionSleep = !sceneItems.some((item) =>
				ProductUtils.hasFeatureSleep(products, models, item.articleId, rangeSettings)
			);
			const disableShowFunctionStorage = !sceneItems.some((item) =>
				ProductUtils.hasFeatureStorage(products, models, item.articleId, rangeSettings)
			);
			const disableShowFunctions = !sceneItems.some((item) =>
				ProductUtils.hasFeature(products, models, item.articleId)
			);
			const disableShowMeasurements = !sceneItems.length;
			const disableShowSelectAll = !sceneItems.length;
			return {
				...state,
				disableShowFunctionSleep,
				disableShowFunctionStorage,
				disableShowFunctions,
				disableShowMeasurements,
				disableShowSelectAll,
			};
		}
		case SET_APP_VIEW: {
			const disableStuff = action.value === 'summary-page';
			const showFunctionSleep = disableStuff ? false : state.showFunctionSleep;
			const showFunctionStorage = disableStuff ? false : state.showFunctionStorage;
			const showFunctions = disableStuff ? false : state.showFunctions;
			const showSelectAll = disableStuff ? false : state.showSelectAll;
			return {
				...state,
				showFunctionSleep,
				showFunctionStorage,
				showFunctions,
				showSelectAll,
			};
		}
		case SET_SELECTED_CONFIGURATION: {
			return {
				...state,
				showSelectAll: false,
				showFunctions: false,
				showFunctionSleep: false,
				showFunctionStorage: false,
			};
		}
		default:
			return state;
	}
}
